import { Schema, ValidationError } from 'yup';

const validateSchema = (
    data: any,
    schema: Schema
): Map<string, string> | null => {
    try {
        schema.validateSync(data, { abortEarly: false });
        return null;
    } catch (err) {
        const errorMap: Map<string, string> = new Map();
        const validationError = err as ValidationError;
        for (const error of validationError.inner) {
            if (!error.path) continue;

            errorMap.set(error.path, error.message);
        }
        return errorMap;
    }
};

export { validateSchema };
